import { render, staticRenderFns } from "./dialogDetailDonors.vue?vue&type=template&id=204086ea"
import script from "./dialogDetailDonors.vue?vue&type=script&lang=js"
export * from "./dialogDetailDonors.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports